module.exports = __webpack_public_path__ + "img.4d4812989960b118ba5e.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/images/img.jpg
// module id = ../../../../../src/assets/images/img.jpg
// module chunks = styles